import { PaymentMethodParams } from 'ha/services/apiV2/types/PaymentMethod';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) => (userId: number) =>
  makeCall<PaymentMethodParams>(
    'GET',
    `/api/v2/user/${userId}/payment-methods/parameters`,
  );
